<template>
  <div>
    <h2 class="page-title mb-5">
      Security
    </h2>

    <b-row class="align-items-end">
      <b-col md="4">
        <b-form-group label="Email Address">
          <b-input
            :value="user.email"
            class="bg-white"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <change-email-modal />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="align-items-end">
      <b-col md="4">
        <b-form-group label="Password">
          <b-input
            type="password"
            class="bg-white"
            value="12345678"
            readonly
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <change-password-modal />
        </b-form-group>
      </b-col>
    </b-row>

    <div class="two-factor mt-4">
      <h3 class="h4 font-weight-bold mb-2">
        Keep your account secure
      </h3>
      <p class="text-muted mb-1">
        Enabling Two-Factor Authentication will provide an extra layer of security for your account.
      </p>
      <p class="text-muted mb-4">
        When logging in, we will ask for a special authentication code from your device.
      </p>

      <div
        v-for="(method, index) in methods"
        :key="method.id"
        class="two-factor__method"
        :class="{'mb-3': index !== methods.length - 1}"
      >
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
          <div class="d-flex align-items-start">
            <b-form-checkbox
              :checked="true"
              disabled
              class="two-factor__checkbox"
              :class="{'opacity-0': !method.enabled}"
              :aria-label="method.title"
            />
            <div>
              <p class="h5 font-weight-bold mb-2">
                {{ method.title }}
              </p>
              <p class="text-muted mb-0">
                {{ method.description }}
              </p>
            </div>
          </div>

          <div class="two-factor__actions mt-3 mt-lg-0">
            <b-button
              :variant="method.enabled ? 'outline-secondary' : 'primary'"
              block
              class="two-factor__action-btn"
              @click="onToggleMethod(method)"
            >
              {{ method.enabled ? 'Disable' : 'Enable' }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import ChangePasswordModal from './components/ChangePasswordModal'
import ChangeEmailModal from './components/ChangeEmailModal'

export default {
  name: 'Main',
  components: {ChangeEmailModal, ChangePasswordModal},
  data () {
    return {
      methods: [
        {
          id: 'app',
          title: 'Authenticator App (Recommended)',
          description: 'Use an authenticator app like Google Authenticator to get verification codes.',
          enabled: false
        },
        // {
        //   id: 'sms',
        //   title: 'SMS Text Message',
        //   description: 'Receive a verification code via text message on your phone.',
        //   enabled: false
        // },
        {
          id: 'email',
          title: 'Email Address',
          description: 'Receive a verification code via email.',
          enabled: false
        }
      ]
    }
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    })
  },
  watch: {
    user: {
      immediate: true,
      handler () {
        const response = this.user
        const raw = response?.verification_method
        const methods = Array.isArray(raw) ? raw : (typeof raw === 'string' && raw.startsWith('[') ? JSON.parse(raw) : [raw].filter(Boolean))

        const enabledById = {
          app: methods.some(m => ['google2FA', 'app', 'authenticator'].includes(m)),
          sms: methods.includes('sms'),
          email: methods.some(m => ['mail', 'email'].includes(m))
        }

        this.methods = this.methods.map((method) => ({
          ...method,
          enabled: Boolean(enabledById[method.id])
        }))
      }
    }
  },
  methods: {
    onToggleMethod (method) {
      if (!method || !method.id) {
        return
      }

      const action = method.enabled ? 'disable' : 'setup'
      const safeId = encodeURIComponent(method.id)
      window.location.href = `https://auth.estage.com/login/two-factor/${action}?ref=${safeId}`
    }
  }
}
</script>

<style scoped>
.two-factor__method {
  padding: 1.25rem;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
}

.two-factor__checkbox {
  margin-top: 0.125rem;
  margin-right: 0.875rem;
}

.two-factor__actions {
  width: 170px;
  min-width: 170px;
}

.two-factor__action-btn {
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .two-factor__actions {
    width: 100%;
    min-width: 100%;
  }
}
</style>
